<img class="placeholder-image" *ngIf="image && !isPlaying" [src]="image + '?w=1920'" [alt]="altText" />
<button type="button" (click)="play()" *ngIf="!isPlaying" class="video-play-button" aria-label="Play">
  <svg-icon class="icon" [ngClass]="{ primary: primary }" src="/assets/icons/play-circle.svg"></svg-icon>
</button>
<video
  [ngClass]="{ 'not-loaded': !isPlaying }"
  controls
  #player
  preload="auto"
  (timeupdate)="updateTime()"
  (ended)="ended()">
  <source [src]="url" />
  Sorry, your browser doesn't support embedded videos.
</video>
